const userManagementReducer = (
    state = {
        companyUsersList: null,
        companyUsersListLoading: false,
        companyTeamsList: null,
        roleUpdated: false,
    },
    action,
) => {
    switch (action.type) {
        case "SET_COMPANY_USERS": {
            return { ...state, companyUsersList: action.payload, companyUsersListLoading: false };
        }
        case "SET_COMPANY_USERS_PENDING": {
            return { ...state, companyUsersList: null, companyUsersListLoading: true };
        }

        case "SET_COMPANY_TEAMS": {
            return { ...state, companyTeamsList: action.payload };
        }
        case "ROLE_UPDATE": {
            return { ...state, roleUpdated: true };
        }
        default:
            return state;
    }
};

export default userManagementReducer;
